/* UltraNiche · global motion engine
   One motion language: ease cubic-bezier(0.16,1,0.3,1), mouse = depth, scroll = camera.
   Gated: html.motion-on (theme setting), prefers-reduced-motion, pointer type.
   All effects are toggleable from Theme settings via data-attrs on <body>. */
(function () {
  "use strict";
  if (window.__unMotionInit) return; window.__unMotionInit = true;

  var html = document.documentElement;
  var REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var COARSE = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  var MOTION = html.classList.contains("motion-on") && !REDUCE;
  if (!MOTION) return;

  var body = document.body;
  var INTENSITY = Math.max(0, Math.min(2, parseInt(body.getAttribute("data-un-intensity") || "60", 10) / 60));
  var WANT_CURSOR = body.getAttribute("data-un-cursor") === "true" && !COARSE;
  var WANT_MAGNET = body.getAttribute("data-un-magnetic") === "true" && !COARSE;
  var WANT_TILT   = body.getAttribute("data-un-tilt") === "true" && !COARSE;
  var WANT_BAR    = body.getAttribute("data-un-progress") === "true";

  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  /* ---------- 1 · Soft custom cursor (decorative; native cursor stays) ---------- */
  if (WANT_CURSOR) {
    var dot = document.createElement("div");
    var ring = document.createElement("div");
    dot.className = "un-cursor-dot"; ring.className = "un-cursor-ring";
    dot.setAttribute("aria-hidden", "true"); ring.setAttribute("aria-hidden", "true");
    body.appendChild(ring); body.appendChild(dot);
    var cx = -100, cy = -100, rx = -100, ry = -100, seen = false;
    var HOT = "a, button, [role='button'], input, textarea, select, .un-btn";
    window.addEventListener("pointermove", function (e) {
      if (e.pointerType === "touch") return;
      cx = e.clientX; cy = e.clientY; seen = true;
      var t = e.target.closest ? e.target.closest(HOT) : null;
      ring.classList.toggle("is-hot", !!t);
    }, { passive: true });
    window.addEventListener("pointerdown", function () { ring.classList.add("is-down"); }, { passive: true });
    window.addEventListener("pointerup", function () { ring.classList.remove("is-down"); }, { passive: true });
    document.addEventListener("mouseleave", function () { dot.style.opacity = "0"; ring.style.opacity = "0"; });
    document.addEventListener("mouseenter", function () { if (seen) { dot.style.opacity = "1"; ring.style.opacity = "1"; } });
    (function cursorLoop() {
      rx = lerp(rx, cx, 0.18); ry = lerp(ry, cy, 0.18);
      dot.style.transform = "translate3d(" + cx + "px," + cy + "px,0)";
      ring.style.transform = "translate3d(" + rx + "px," + ry + "px,0)";
      requestAnimationFrame(cursorLoop);
    })();
  }

  /* ---------- 2 · Magnetic buttons ---------- */
  function magnetize(btn) {
    if (btn.__unMag) return; btn.__unMag = true;
    var tx = 0, ty = 0, x = 0, y = 0, raf = 0;
    var strength = 0.28 * INTENSITY;
    function loop() {
      x = lerp(x, tx, 0.16); y = lerp(y, ty, 0.16);
      btn.style.transform = "translate3d(" + x.toFixed(2) + "px," + y.toFixed(2) + "px,0)";
      if (Math.abs(tx - x) > 0.05 || Math.abs(ty - y) > 0.05) raf = requestAnimationFrame(loop);
      else { raf = 0; if (!tx && !ty) btn.style.transform = ""; }
    }
    btn.addEventListener("pointermove", function (e) {
      if (e.pointerType === "touch") return;
      btn.setAttribute("data-un-magnetized", "");
      var r = btn.getBoundingClientRect();
      tx = (e.clientX - (r.left + r.width / 2)) * strength;
      ty = (e.clientY - (r.top + r.height / 2)) * strength;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    btn.addEventListener("pointerleave", function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop); });
  }

  /* ---------- 3 · 3D tilt on cards / photos ---------- */
  function tiltify(card) {
    if (card.__unTilt) return; card.__unTilt = true;
    var deg = (parseFloat(card.getAttribute("data-tilt")) || 7) * INTENSITY;
    var tX = 0, tY = 0, X = 0, Y = 0, raf = 0;
    card.style.transformStyle = "preserve-3d";
    function loop() {
      X = lerp(X, tX, 0.12); Y = lerp(Y, tY, 0.12);
      card.style.transform = "perspective(800px) rotateX(" + X.toFixed(2) + "deg) rotateY(" + Y.toFixed(2) + "deg)";
      if (Math.abs(tX - X) > 0.02 || Math.abs(tY - Y) > 0.02) raf = requestAnimationFrame(loop);
      else { raf = 0; if (!tX && !tY) card.style.transform = ""; }
    }
    card.addEventListener("pointermove", function (e) {
      if (e.pointerType === "touch") return;
      card.setAttribute("data-un-tilted", "");
      var r = card.getBoundingClientRect();
      tY = ((e.clientX - r.left) / r.width - 0.5) * 2 * deg;
      tX = -((e.clientY - r.top) / r.height - 0.5) * 2 * deg;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    card.addEventListener("pointerleave", function () { tX = 0; tY = 0; if (!raf) raf = requestAnimationFrame(loop); });
  }

  /* ---------- 4 · Scroll progress thread ---------- */
  if (WANT_BAR) {
    var bar = document.createElement("div");
    bar.className = "un-progress"; bar.setAttribute("aria-hidden", "true");
    body.appendChild(bar);
  }

  /* ---------- 5 · Hero camera pull-back on scroll ---------- */
  var heroInner = document.querySelector(".unhero .unhero-inner");
  var heroEl = document.querySelector(".unhero");

  /* ---------- shared scroll loop (one listener, rAF-throttled) ---------- */
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(scrollFrame); } }
  function scrollFrame() {
    ticking = false;
    var doc = document.documentElement;
    if (WANT_BAR) {
      var max = (doc.scrollHeight - window.innerHeight) || 1;
      bar.style.transform = "scaleX(" + clamp(window.scrollY / max, 0, 1).toFixed(4) + ")";
    }
    if (heroInner && heroEl) {
      var hr = heroEl.getBoundingClientRect();
      if (hr.bottom > 0) {
        var p = clamp(-hr.top / Math.max(hr.height, 1), 0, 1); /* 0 at top · 1 scrolled past */
        heroInner.style.opacity = (1 - p * 0.9).toFixed(3);
        heroInner.style.transform = "translate3d(0," + (p * 60 * INTENSITY).toFixed(1) + "px,0) scale(" + (1 - p * 0.06 * INTENSITY).toFixed(4) + ")";
      }
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();

  /* ---------- init / re-init (theme editor safe) ---------- */
  function scan(root) {
    root = root || document;
    if (WANT_MAGNET) root.querySelectorAll(".un-btn, .unc-btn, [data-magnetic]").forEach(magnetize);
    if (WANT_TILT) root.querySelectorAll("[data-tilt]").forEach(tiltify);
  }
  scan();
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); onScroll(); });
})();
